import { createRootRoute, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { NavbarComponent } from "@/components";
import { getCurrentUser } from "@/api";

export const Route = createRootRoute({
  component: () => {
    return (
      <>
        <NavbarComponent />
        <Outlet />
        <TanStackRouterDevtools />
      </>
    );
  },
  loader: getCurrentUser,
  errorComponent: () => (
    <>
      <NavbarComponent />
      <div>Login to continue</div>
      <TanStackRouterDevtools />
    </>
  ),
});
